<template>
<b-row>
  <b-col cols="1"><span class="text-danger" style="font-size: 50px; font-weight: 700;">1</span></b-col>
  <b-col md="11" lg="6" class="pt-3">
    <b-btn block href="#" v-b-toggle.stack-accordion-01 variant="outline-danger" class="text-danger rounded-0 py-0" style="font-size: 24px; font-weight: 700">
      <b-row align-v="center">
        <div class="bg-danger" style="height: 50px; width: 50px;">
          <div class="pt-1"><img src="/images/linked-data-icon.png" height="30"></div>
        </div>
        <div style="text-align: left">
          Linked Data Platform
          <font-awesome-icon :icon="iconCaretDown" size="1" />
        </div>
      </b-row>
    </b-btn>
  </b-col>
  <b-row>
    <b-col cols="11" offset="1">
      <b-collapse id="stack-accordion-01" accordion="stack-accordion" class="px-3">
        <h2 style="color: #2e145e;">Link Your Data Silos</h2>
        <p>graphMetrix transforms your legacy data into universally understood linked data. The Solid Linked Data Platform establishes a global API where all applications are able to exchange linked data within a decentralized peer to peer network of Pods without custom programming for each application.</p>
        <img src="/images/linked_data_graph.png" class="img-fluid">
      </b-collapse>
    </b-col>
  </b-row>
</b-row>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
export default {
  name: 'stack01',
  components: {
      FontAwesomeIcon
    },
    data () {
      return {
        iconCaretDown: faCaretDown
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.text-danger:hover {
  color: #f8f9fa !important;
}
</style>
